import { Helmet } from 'react-helmet-async';
import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import profile from 'src/store/profile';
import api from 'src/utils/api';
// @mui
import {
  Grid,
  Container,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  Snackbar,
  Alert,
  Card,
  CardHeader,
  CardContent,
} from '@mui/material';
import { CreateMessage } from 'src/sections/@dashboard/student';
import { MessageNews } from 'src/sections/@dashboard/app';

// ----------------------------------------------------------------------

export default function InfoPage() {
  const location = useLocation();
  
  const [alert, setAlert] = useState(false);
  const [messages, setMessages] = useState([]);
  const [feedbacks, setFeedbacks] = useState([]);
  const [student] = useState(profile.isTeacher ? location.state : profile.data);
  const [groups, setGroups] = useState([]);
  const [group, setGroup] = useState(!profile.isTeacher ? profile.data.sgroup_id : false);

  const getMessages = useCallback(() => {
    api.get(`message-api?sort=-id&filter[type]=2&filter[group_id]=${group}`)
      .then((result) => {
        setMessages(result);
      })
      .catch(() => {
        setMessages([]);
      });
  }, [group]);

  const getFeedbacks = useCallback(() => {
    if (!profile.isTeacher)
      api.get(`feedback-api?sort=-id&filter[student_id]=${profile.data.id}`)
        .then((result) => {
          setFeedbacks(result);
        })
        .catch(() => {
          setFeedbacks([]);
        });
  }, []);

  useEffect(() => {
    if (group) {
      getMessages();
      getFeedbacks();
    }
  }, [group, getMessages, getFeedbacks]);

  useEffect(() => {
    if (profile.isTeacher)
      api.get(`sgroup-api?filter[date_end][neq]='0000-00-00'&filter[teacher_id]=${profile.data.id}`)
        .then((result) => {
          setGroups(result);
          if (result && result.length) setGroup(result[0].id);
        })
        .catch(() => {
          setGroups([]);
        });
  }, []);

  return (
    <>
      <Helmet>
        <title> Профіль | Lala English </title>
      </Helmet>

      {profile.isTeacher ? (
        <Alert severity="error" sx={{ mb: 5, pl: 3 }}>На цій сторінці ви можете надсилати повідомлення для усіх студентів будь-якої вашої групи студентів.</Alert>
      ) : (
        <Alert severity="error" sx={{ mb: 5, pl: 3 }}>Повідомлення від Lala та фідбеки для батьків.</Alert>
      )}
      <Container maxWidth="xl">
        {profile.isTeacher ? (
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Група</InputLabel>
              <Select
                // labelId="demo-simple-select-label"
                // id="demo-simple-select"
                value={groups.length > 0 ? group : ''}
                label="Група"
                onChange={(event) => setGroup(event.target.value)}
              >
                {groups.map((value) => (
                    <MenuItem key={value.id} value={value.id}>
                      {value.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Stack>
        ) : null}

        <Grid container spacing={3} sx={{ 'flexDirection': profile.isTeacher ? 'row-reverse' : 'row' }}>
          {profile.isTeacher && group ? (
            <Grid item xs={12} md={6} lg={4}>
              <Card>
                <CardHeader title="Нове повідомлення для групи:" />

                <CardContent>
                  <CreateMessage
                    groupid={group}
                    type={2}
                    student={student}
                    success={() => {
                      getMessages();
                      setAlert(true);
                    }}
                  />
                </CardContent>
              </Card>
            </Grid>
          ) : null}
          <Grid item xs={12} md={6} lg={profile.isTeacher ? 8 : 6}>
            <MessageNews
              title={!profile.isTeacher ? 'Останні повідомлення від Lala:' : 'Повідомлення для всієї групи:'}
              list={messages.map((message) => ({
                id: message.id,
                title: 'Lala',
                description: message.text,
                image: `/assets/images/covers/cover_5.jpg`,
                postedAt: message.date,
                link: message.link,
              }))}
            />
          </Grid>
          {!profile.isTeacher && feedbacks.length ? (
            <Grid item xs={12} md={6} lg={6}>
              <MessageNews
                title="Фідбеки для батьків:"
                list={feedbacks.map((message) => ({
                  id: message.id,
                  title: 'Lala',
                  description: message.text,
                  image: `/assets/images/covers/cover_5.jpg`,
                  postedAt: message.date,
                  link: '',
                }))}
              />
            </Grid>
          ) : null}
          <Snackbar open={alert} autoHideDuration={4000} onClose={() => setAlert(false)}>
            <Alert severity="success" variant="filled" sx={{ width: '100%' }}>
              Успішно відправлено!
            </Alert>
          </Snackbar>
        </Grid>
      </Container>
    </>
  );
}
